import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DispatcherPageComponent } from './components/pages/dispatcher-page/dispatcher-page.component';
import { LandingPageComponent } from './components/pages/landing-page/landing-page.component';
import { LoginPageComponent } from './components/pages/login-page/login-page.component';
import { routes as routesCatalog } from './utils/catalog';
import { LoginGuard } from './guards/login.guard';

const routes: Routes = [
  {
    path: routesCatalog.login.relativeUrl,
    component: LoginPageComponent,
  },
  {
    path: routesCatalog.dispatcher.relativeUrl,
    component: DispatcherPageComponent,
    canActivate: [LoginGuard],
    children: [
      {
        path: routesCatalog.landing.relativeUrl,
        component: LandingPageComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
